import { render, staticRenderFns } from "./FolderTopBar.vue?vue&type=template&id=0549c56e"
import script from "./FolderTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderTopBar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports